import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  id: 1,
  nombre: 'Fundamentos del Codigo Sensorial'
}, {
  id: 2,
  nombre: 'Evaluacion y Decodificacion Sensorial'
}, {
  id: 3,
  nombre: 'Mapeo y Priorizacion Terapeutica'
}, {
  id: 4,
  nombre: 'Intervencion por Sistemas Sensoriales'
}, {
  id: 5,
  nombre: 'Diseno de Dietas Sensoriales Estructuradas'
}, {
  id: 6,
  nombre: 'Regulacion y Manejo de Crisis Sensorial'
}, {
  id: 7,
  nombre: 'Aplicacion en 3 Contextos'
}, {
  id: 8,
  nombre: 'Seguimiento y Ajuste Profesional'
}];
export function NexusSection() {
  return <section className="bg-white py-16 px-6" data-id="element-115">
      <div className="max-w-6xl mx-auto text-center px-4" data-id="element-116">
        <p className="font-display font-extrabold text-sm md:text-base tracking-[0.25em] uppercase text-brand-green mb-4" data-id="element-117">
          Sistema NEXUS-S
        </p>

        <h2 className="font-display font-black text-5xl md:text-7xl uppercase mb-8 text-brand-ink leading-tight" data-id="element-118">
          SISTEMA NEXUS-S
        </h2>

        <p className="text-gray-700 text-2xl md:text-3xl max-w-4xl mx-auto mb-16 font-semibold leading-relaxed" data-id="element-119">
          El Sistema NEXUS-S organiza la intervencion en 8 modulos progresivos
          para que <span className="text-brand-green" data-id="element-120">nunca improvises.</span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-121">
          {modules.map(modulo => <div key={modulo.id} className="bg-brand-mint border-2 border-brand-green/20 rounded-xl p-8 flex flex-col items-center justify-center text-center min-h-[240px] relative overflow-hidden group hover:border-brand-green transition-all duration-500 hover:shadow-2xl" data-id="element-122">
              {/* Imagen de fondo con efecto Zoom al hacer Scroll */}
              <motion.div initial={{
            scale: 1,
            opacity: 0.12
          }} whileInView={{
            scale: 1.15,
            opacity: 0.15
          }} viewport={{
            once: false,
            margin: '-50px'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="absolute inset-0 z-0 mix-blend-multiply pointer-events-none" style={{
            backgroundImage: "url('https://cdn.shopify.com/s/files/1/0645/1485/0950/files/hero-terapeuta-nino-tea.png?v=1772627948')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }} data-id="element-123" />

              {/* Número del módulo estilizado en el fondo */}
              <div className="absolute -right-4 -top-4 text-brand-green/10 font-display font-black text-8xl group-hover:text-brand-green/25 transition-colors pointer-events-none z-10" data-id="element-124">
                {modulo.id}
              </div>

              {/* Contenido Principal */}
              <div className="relative z-20 flex flex-col items-center" data-id="element-125">
                <span className="font-display font-black text-brand-green-dark md:text-xs uppercase tracking-[0.25em] mb-4 bg-white/80 backdrop-blur-sm shadow-sm px-4 py-1.5 rounded-full border border-brand-green/10 text-[18px]" data-id="element-126">
                  Módulo {modulo.id}
                </span>

                <h3 className="font-display font-bold text-brand-ink text-xl md:text-2xl leading-tight max-w-[280px]" data-id="element-127">
                  {modulo.nombre}
                </h3>
              </div>

              {/* Decoración inferior sutil */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-green/30 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-128" />
            </div>)}
        </div>
      </div>
    </section>;
}